<app-modal-container
    #modalContainer
    (onClose)="close()"
    (onSave)="save()"
    [width]="400"
>
<!--  <div class="modal-header">-->
<!--    -->

<!--  </div>-->
  <div class="modal-body">
    <div class="title-holder">
      <span class="icon">
        <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M25.5442 10.4154L14.8548 21.1049H5.77147V12.0216L16.4609 1.33211L25.5442 10.4154Z" fill="url(#paint0_linear_31116_36844)" stroke="url(#paint1_linear_31116_36844)"/>
          <path d="M5.27181 11.8141L16.4609 0.625L18.8768 3.04083L7.68764 14.23L5.27181 21.6046L5.27181 11.8141Z" fill="url(#paint2_linear_31116_36844)"/>
          <path d="M5.27344 21.605V18.4258L8.45266 21.605H5.27344Z" fill="#010101"/>
          <defs>
          <linearGradient id="paint0_linear_31116_36844" x1="21.3562" y1="5.52024" x2="4.91981" y2="-4.61088" gradientUnits="userSpaceOnUse">
          <stop/>
          <stop offset="1" stop-color="white"/>
          </linearGradient>
          <linearGradient id="paint1_linear_31116_36844" x1="25.8329" y1="7.52248" x2="14.6957" y2="4.41288" gradientUnits="userSpaceOnUse">
          <stop stop-color="white" stop-opacity="0"/>
          <stop offset="0.428115" stop-color="white" stop-opacity="0.81428"/>
          <stop offset="1" stop-color="white" stop-opacity="0"/>
          </linearGradient>
          <linearGradient id="paint2_linear_31116_36844" x1="13.8189" y1="1.82522" x2="9.4981" y2="21.7488" gradientUnits="userSpaceOnUse">
          <stop stop-color="white"/>
          <stop offset="1" stop-color="white" stop-opacity="0"/>
          </linearGradient>
          </defs>
        </svg>
      </span>
      <h2>Скасувати персональну пропозицію</h2>
    </div>

    <div>
      <div class="form-group">
        <span class="subtitle">Причина скасування</span>
        <textarea #textEl></textarea>
      </div>
    </div>

    <div class="flex justify-content-center">
      <button class="btn btn-grey" (click)="cancel()">
        Відмінити
      </button>
      <button class="btn btn-black" (click)="save()">Підтвердити</button>
    </div>

  </div>

  <app-loading-animation *ngIf="isLoading"></app-loading-animation>
</app-modal-container>